/*
 * Copyright © 2021, CodeVision. All rights reserved.
 *
 * This file was generated by Codevision's stub generator
 */

export enum OsType {
  ANDROID = 0,
  IOS = 1,
  WEB = 2,
}

export namespace OsType {
  export function values() {
    return Object.keys(OsType).filter((type) => isNaN(type as any) && type !== 'values');
  }
}
